import { FC } from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage: FC = () => {
  return (
    <div className="min-h-screen bg-surface-primary flex items-center justify-center p-6">
      <div className="max-w-2xl w-full text-center">
        <div className="mb-8">
          <h1 className="text-9xl font-black text-accent mb-4">404</h1>
          <h2 className="text-3xl font-bold text-content-primary mb-4">Página não encontrada</h2>
          <p className="text-content-secondary text-lg mb-8">
            A página que você está procurando não existe ou foi movida.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/"
            className="bg-accent hover:bg-accent-hover text-accent-contrast px-8 py-4 rounded-xl font-bold transition-all flex items-center justify-center gap-2"
          >
            <span className="material-symbols-outlined">home</span>
            Voltar para Home
          </Link>
          <Link
            to="/play"
            className="bg-surface-secondary border border-theme-border hover:bg-surface-hover text-content-primary px-8 py-4 rounded-xl font-bold transition-all flex items-center justify-center gap-2"
          >
            <span className="material-symbols-outlined">sports_esports</span>
            Ir para Jogos
          </Link>
        </div>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-3 gap-6">
          <Link
            to="/trilhas"
            className="bg-surface-secondary border border-theme-border hover:bg-surface-hover p-6 rounded-xl transition-all group"
          >
            <span className="material-symbols-outlined text-4xl text-accent mb-2 block group-hover:scale-110 transition-transform">
              explore
            </span>
            <h3 className="text-content-primary font-bold mb-1">Trilhas</h3>
            <p className="text-content-secondary text-sm">Explore conteúdos</p>
          </Link>
          <Link
            to="/ranking"
            className="bg-surface-secondary border border-theme-border hover:bg-surface-hover p-6 rounded-xl transition-all group"
          >
            <span className="material-symbols-outlined text-4xl text-accent mb-2 block group-hover:scale-110 transition-transform">
              leaderboard
            </span>
            <h3 className="text-content-primary font-bold mb-1">Ranking</h3>
            <p className="text-content-secondary text-sm">Veja sua posição</p>
          </Link>
          <Link
            to="/"
            className="bg-surface-secondary border border-theme-border hover:bg-surface-hover p-6 rounded-xl transition-all group"
          >
            <span className="material-symbols-outlined text-4xl text-accent mb-2 block group-hover:scale-110 transition-transform">
              dashboard
            </span>
            <h3 className="text-content-primary font-bold mb-1">Dashboard</h3>
            <p className="text-content-secondary text-sm">Suas estatísticas</p>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
